// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\App\Users\Tenant\Enums\TenantUserField
// Generated on: <normalized>

export enum TenantUserField {
  DB_TABLE = 'tenant_users',
  DB_IDENTIFIER = 'userGUID',
  EMAIL = 'email',
  PASSWORD = 'password',
  IS_ACTIVE = 'isActive',
  DISABLE_LOGIN = 'disableLogin',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE_NUMBER = 'phoneNumber',
  DEPARTMENT = 'department',
  JOB_TITLE = 'jobTitle',
  ROLE_GUID = 'roleGUID',
  TIMEZONE = 'timezone',
  LANGUAGE = 'language',
  DATE_FORMAT = 'dateFormat',
  DASHBOARD = 'dashboard',
  AVATAR_FILE_DATA = 'avatarFileData',
  BOOLEAN_SETTINGS = 'booleanSettings',
  NOTES = 'notes',
  CREATED_BY_USER_GUID = 'createdByUserGUID',
  SECURITY_VERSION = 'securityVersion',
  REMEMBER_TOKEN = 'rememberToken',
  LAST_LOGIN_AT = 'lastLoginAt',
  LAST_ACTIVITY_AT = 'lastActivityAt',
  PASSWORD_CONFIRMATION = 'passwordConfirmation',
}

export const TenantUserFieldWritableFields = ["email", "password", "firstName", "lastName", "phoneNumber", "department", "jobTitle", "roleGUID", "isActive", "disableLogin", "timezone", "language", "dateFormat", "dashboard", "avatarFileData", "booleanSettings", "notes", "passwordConfirmation"] as const;

export const TenantUserFieldGetEncryptionFields = [] as const;

export const TenantUserFieldCases = ["tenant_users", "userGUID", "email", "password", "isActive", "disableLogin", "firstName", "lastName", "phoneNumber", "department", "jobTitle", "roleGUID", "timezone", "language", "dateFormat", "dashboard", "avatarFileData", "booleanSettings", "notes", "createdByUserGUID", "securityVersion", "rememberToken", "lastLoginAt", "lastActivityAt", "passwordConfirmation"] as const;
